import { render } from "./permisosUser.vue?vue&type=template&id=40de47ec&scoped=true"
import script from "./permisosUser.vue?vue&type=script&lang=js"
export * from "./permisosUser.vue?vue&type=script&lang=js"

import "./permisosUser.vue?vue&type=style&index=0&id=40de47ec&scoped=true&lang=css"
import "./permisosUser.vue?vue&type=style&index=1&id=40de47ec&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40de47ec"]])

export default __exports__